import { MonthlyChecklistRepository } from "../../repositories/MonthlyChecklistRepository";
import { MonthlyChecklistEntity } from "../../entities/MonthlyChecklistEntity";

/**
 * Get Checklist By ID Use Case
 */
export class GetChecklistByIdUseCase {
  constructor(private repository: MonthlyChecklistRepository) {}

  async execute(checklistId: number): Promise<MonthlyChecklistEntity | null> {
    return await this.repository.getChecklistById(checklistId);
  }
}

